import { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import ValidationLegacyStrings from '@bingads-webui-clientcenter/validation-legacy-strings';

export const useI18n = () => useContext(I18nContext);

export const useValidationI18n = () => {
  const i18n = useI18n();
  return useMemo(() => buildLegacyI18n(i18n, ValidationLegacyStrings), [i18n]);
};
